import { getStreetTypesState } from './../../street-types/street-types.selectors';
import { FetchStreetTypesRequest } from './../../street-types/street-types.actions';
import { getUpdateStreetState } from './../streets.selectors';
import Validator from '@shared/validatorjs/src/validator';
import { SetDefaultData, FetchStreetRequest, UpdateField, UpdateStreetRequest } from './../streets.actions';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import FormTrait from 'src/app/traits/form.trait';
import { Subscription } from 'rxjs';
import { Map } from 'immutable';

@Component({
  selector: 'app-update-street',
  templateUrl: './update-street.component.html',
  styleUrls: ['./update-street.component.css']
})
export class UpdateStreetComponent extends FormTrait implements OnInit, OnDestroy {

  public streetTypes: any[];
  private state$: Subscription;
  private streetTypesState$: Subscription;
  public isLoading: boolean;
  public userId: number;

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.userId = parseInt(this.route.snapshot.paramMap.get("id"))
    this.store.dispatch<any>(new SetDefaultData('updateStreet'))

    this.streetTypesState$ = this.store.pipe(select(getStreetTypesState)).subscribe(streetTypes => {
      this.streetTypes = streetTypes.get('data').toJS();
    });

    this.state$ = this.store.pipe(select(getUpdateStreetState)).subscribe(state => {
      this.state = state;
      this.isLoading = state.get('isLoading')
    });

    this.store.dispatch<any>(new FetchStreetRequest(this.userId))

    this.store.dispatch<any>(
      new FetchStreetTypesRequest()
    );
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.streetTypesState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {

    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'updateStreet.data')
    );

    this.store.dispatch(
      new UpdateField('validationErrors', this.state
        .get('validationErrors')
        .delete(name || e.target.name), 'updateStreet')
    );
  }

  validation() {
    const data = this.state.get('data');
    const rules = {
      name: "required",
      // streetTypeId: "required"
    };
    const validator = new Validator(
      {
        name: data.get('name'),
        streetTypeId: data.get('streetTypeId')
      },
      rules,
    );

    validator.setAttributeNames({
      streetTypeId: "street type",
    });

    return validator;
  }

  public onSubmit(e: Event): void {

    e.preventDefault();

    const validation = this.validation();
    const payload = this.state.get('data').toJS();

    if (validation.passes()) {
      this.store.dispatch(new UpdateStreetRequest(this.userId, payload));
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'updateStreet')
      );
    }
  }

}
